<template>
  <SecondaryButton @click="$emit('open')">
    <ChatAlt2Icon class="h-4 w-4 mr-1.5" aria-hidden="true" />
    {{ t("label") }}
  </SecondaryButton>
</template>

<script>
import { useI18n } from "vue-i18n";
import { SecondaryButton } from "@estaly/ui";
import { ChatAlt2Icon } from "@heroicons/vue/outline";

export default {
  name: "ClaimChatButton",

  components: { SecondaryButton, ChatAlt2Icon },

  setup() {
    const { t } = useI18n();
    return { t };
  },

  emits: ["open"],
};
</script>

<i18n src="./ClaimChatButton.i18n.json"></i18n>
